// This file is auto-generated by @hey-api/openapi-ts

import type {
  BackgroundTasksTasksRetrieveResponse,
  DirectoutreachBetanxtVoterPolicySnapshotExportCreateResponse,
  DirectoutreachPolicyAvailableListResponse,
  DirectoutreachPolicyAvailableRetrieveResponse,
  DirectoutreachPolicyCreateResponse,
  DirectoutreachVotersCreateCreateResponse,
  DirectoutreachVotersHoldingsRetrieveResponse,
  DirectoutreachVotersSelectedPolicyCreateResponse,
  DirectoutreachVotersSelectedPolicyRetrieveResponse,
  DirectvotingCustodyAccountsCreateResponse,
  DirectvotingCustodyAccountsListResponse,
  DirectvotingCustodyAccountsPartialUpdateResponse,
  DirectvotingCustodyAccountsRetrieveResponse,
  DirectvotingCustodyAccountsUpdateResponse,
  DirectvotingCustodyAccountVoterLinksLinkCreateResponse,
  DirectvotingCustodyAccountVoterLinksListResponse,
  DirectvotingCustodyAccountVotingPolicySelectionsCreateResponse,
  DirectvotingCustodyAccountVotingPolicySelectionsPartialUpdateResponse,
  DirectvotingCustodyAccountVotingPolicySelectionsRetrieveResponse,
  DirectvotingCustodyAccountVotingPolicySelectionsSearchCreateResponse,
  DirectvotingCustodyAccountVotingPolicySelectionsUpdateResponse,
  DirectvotingVotersBallotsCastVoteCreateResponse,
  DirectvotingVotersBallotsProposalsRetrieveResponse,
  DirectvotingVotersBallotsSearchCreateResponse,
  DirectvotingVotersCreateResponse,
  DirectvotingVotersListResponse,
  DirectvotingVotersMeetingsSearchCreateResponse,
  DirectvotingVotersPartialUpdateResponse,
  DirectvotingVotersRetrieveResponse,
  DirectvotingVotersUpdateResponse,
  FundManagerFundManagersCreateResponse,
  FundManagerFundManagersPoliciesCreateResponse,
  FundManagerFundManagersPoliciesRetrieveResponse,
  FundManagerFundManagersRetrieveResponse,
  FundManagerFundManagersSearchCreateResponse,
  FundManagerFundManagersUpdateResponse,
  FundManagerFundsCreateResponse,
  FundManagerFundsQuantificationSnapshotsCreateResponse,
  FundManagerFundsRetrieveResponse,
  FundManagerFundsSearchCreateResponse,
  FundManagerFundsUpdateResponse,
  FundManagerFundVariantsCreateResponse,
  FundManagerFundVariantsRetrieveResponse,
  FundManagerFundVariantsSearchCreateResponse,
  FundManagerFundVariantsUpdateResponse,
  FundManagerProvidersCreateResponse,
  FundManagerProvidersListResponse,
  FundManagerProvidersRetrieveResponse,
  FundManagerProvidersUpdateResponse,
  FundManagerQuantificationSnapshotsSearchCreateResponse,
  InstitutionalMeetingsearchListResponse,
  ProxyIntermediaryBallotsFetchByVersionIdsCreateResponse,
  ProxyIntermediaryBallotsSearchCreateResponse,
  ProxyIntermediaryBallotsUpsertCreateResponse,
  ProxyIntermediaryBallotsVersionsListResponse,
  ProxyIntermediaryProposalsCreateCreateResponse,
  ProxyIntermediaryProposalsSearchCreateResponse,
  ProxyIntermediaryProxyIntermediariesSearchCreateResponse,
  ProxyIntermediaryProxyIntermediaryMeetingsAuditEventsSearchCreateResponse,
  ProxyIntermediaryProxyIntermediaryMeetingsCancelCreateResponse,
  ProxyIntermediaryProxyIntermediaryMeetingsLinkTransparencyGeneralMeetingCreateResponse,
  ProxyIntermediaryProxyIntermediaryMeetingsSearchCreateResponse,
  ProxyIntermediaryProxyIntermediaryMeetingsUnlinkTransparencyGeneralMeetingCreateResponse,
  ProxyIntermediaryProxyIntermediaryMeetingsUpsertCreateResponse,
  ProxyvotingEntitlementsListResponse,
  ProxyvotingFundManagerPolicySupportedIssuedInstrumentsCreateResponse,
  ProxyvotingFundManagerPolicySupportedIssuedInstrumentsSearchCreateResponse,
  ProxyvotingFundManagerSupportedPoliciesCreateResponse,
  ProxyvotingFundManagerSupportedPoliciesListResponse,
  ProxyvotingInvestorCompositionsDifferenceListResponse,
  ProxyvotingInvestorCompositionsRulesEngineRetrieveResponse,
  ProxyvotingInvestorCompositionsRulesEngineUpdateResponse,
  ProxyvotingInvestorPolicySupportedIssuedInstrumentsCreateResponse,
  ProxyvotingInvestorPolicySupportedIssuedInstrumentsSearchCreateResponse,
  ProxyvotingInvestorSupportedIssuedInstrumentsCreateResponse,
  ProxyvotingInvestorSupportedIssuedInstrumentsSearchCreateResponse,
  ProxyvotingMeetingBallotsListResponse,
  ProxyvotingMeetingBallotSourcesListResponse,
  ProxyvotingPiballotsFilterListResponse,
  ProxyvotingPimeetingsFilterListResponse,
  ProxyvotingRulesEngineDefinitionsCreateResponse,
  ProxyvotingRulesEngineDefinitionsListResponse,
  ProxyvotingRulesEngineDefinitionsRetrieveResponse,
  ProxyvotingRulesEngineDefinitionsRulesCreateResponse,
  ProxyvotingRulesEngineDefinitionsRulesListResponse,
  ProxyvotingRulesEngineDefinitionsRulesUpdateResponse,
  ProxyvotingSviProposalOverwriteCreateResponse,
  TransparencyAuditEventsSearchCreateResponse,
  TransparencyExternalMeetingIdsCreateResponse,
  TransparencyGeneralMeetingsCreateResponse,
  TransparencyGeneralMeetingsPartialUpdateResponse,
  TransparencyGeneralMeetingsRetrieveResponse,
  TransparencyGeneralMeetingsSearchCreateResponse,
  TransparencyOrganizationsCreateResponse,
  TransparencyOrganizationsGeneralMeetingsProposalsCreateResponse,
  TransparencyOrganizationsGeneralMeetingsProposalsPartialUpdateResponse,
  TransparencyOrganizationsGeneralMeetingsProposalsRetrieveResponse,
  TransparencyOrganizationsGeneralMeetingsProposalsSearchCreateResponse,
  TransparencyOrganizationsGeneralMeetingsProposalsUpdateResponse,
  TransparencyOrganizationsGetByIdentifierCreateResponse,
  TransparencyOrganizationsLogoCreateResponse,
  TransparencyOrganizationsPartialUpdateResponse,
  TransparencyOrganizationsRetrieveResponse,
  TransparencyOrganizationsSearchCreateResponse,
  TransparencyOrganizationsUpdateResponse,
  TransparencyProposalsFetchCreateResponse,
  TransparencyPublicSecurityIdsSearchCreateResponse,
  VotingOperationsPiballotsFilterListResponse,
  VotingOperationsPimeetingsFilterListResponse,
  VotingPolicyProposalSetRecommendationCoverageDetailRetrieveResponse,
  VotingPolicyProposalSetRecommendationCoverageSearchCreateResponse,
  VotingPolicyProviderVotingRecommendationsCreateResponse,
  VotingPolicyProviderVotingRecommendationsFetchByVersionRetrieveResponse,
  VotingPolicyProviderVotingRecommendationsMatchCreateResponse,
  VotingPolicyProviderVotingRecommendationsSearchCreateResponse,
  VotingPolicyProxyIntermediaryVotingRecommendationConfidenceScoresUpdateResponse,
  VotingPolicyProxyIntermediaryVotingRecommendationsCreateResponse,
  VotingPolicyProxyIntermediaryVotingRecommendationsMatchFromPvrCreateResponse,
  VotingPolicyProxyIntermediaryVotingRecommendationsSearchCreateResponse,
  VotingPolicyProxyIntermediaryVotingRecommendationsVersionsRetrieveResponse,
  VotingPolicyVotingPoliciesCreateResponse,
  VotingPolicyVotingPoliciesDocumentsCreateResponse,
  VotingPolicyVotingPoliciesDocumentsListResponse,
  VotingPolicyVotingPoliciesDocumentsPartialUpdateResponse,
  VotingPolicyVotingPoliciesDocumentsRetrieveResponse,
  VotingPolicyVotingPoliciesPartialUpdateResponse,
  VotingPolicyVotingPoliciesRetrieveResponse,
  VotingPolicyVotingPoliciesSearchCreateResponse,
  VotingPolicyVotingPoliciesVotingRecommendationsCreateResponse,
  VotingPolicyVotingPoliciesVotingRecommendationsPartialUpdateResponse,
  VotingPolicyVotingPoliciesVotingRecommendationsRetrieveResponse,
  VotingPolicyVotingPoliciesVotingRecommendationsSearchCreateResponse,
  VotingPolicyVotingPoliciesVotingRecommendationsUpdateFromPvrCreateResponse,
  VotingPolicyVotingRecommendationConfidenceScoresUpdateResponse,
} from './types.gen'

const taskStatusSchemaResponseTransformer = (data: any) => {
  data.scheduled_at = new Date(data.scheduled_at)
  if (data.started_at) {
    data.started_at = new Date(data.started_at)
  }
  return data
}

export const backgroundTasksTasksRetrieveResponseTransformer = async (
  data: any
): Promise<BackgroundTasksTasksRetrieveResponse> => {
  data = taskStatusSchemaResponseTransformer(data)
  return data
}

const exportResultSchemaResponseTransformer = (data: any) => {
  data.exported_at = new Date(data.exported_at)
  return data
}

export const directoutreachBetanxtVoterPolicySnapshotExportCreateResponseTransformer = async (
  data: any
): Promise<DirectoutreachBetanxtVoterPolicySnapshotExportCreateResponse> => {
  data = exportResultSchemaResponseTransformer(data)
  return data
}

const policySchemaResponseTransformer = (data: any) => {
  data.create_time = new Date(data.create_time)
  data.update_time = new Date(data.update_time)
  return data
}

export const directoutreachPolicyCreateResponseTransformer = async (
  data: any
): Promise<DirectoutreachPolicyCreateResponse> => {
  data = policySchemaResponseTransformer(data)
  return data
}

const policyResponseSchemaResponseTransformer = (data: any) => {
  data.create_time = new Date(data.create_time)
  data.update_time = new Date(data.update_time)
  return data
}

export const directoutreachPolicyAvailableListResponseTransformer = async (
  data: any
): Promise<DirectoutreachPolicyAvailableListResponse> => {
  data = data.map((item: any) => policyResponseSchemaResponseTransformer(item))
  return data
}

export const directoutreachPolicyAvailableRetrieveResponseTransformer = async (
  data: any
): Promise<DirectoutreachPolicyAvailableRetrieveResponse> => {
  data = policyResponseSchemaResponseTransformer(data)
  return data
}

const holdingSchemaResponseTransformer = (data: any) => {
  data.valid_time = new Date(data.valid_time)
  data.create_time = new Date(data.create_time)
  data.update_time = new Date(data.update_time)
  return data
}

const holdingResponseSchemaResponseTransformer = (data: any) => {
  data.holdings = data.holdings.map((item: any) => holdingSchemaResponseTransformer(item))
  return data
}

export const directoutreachVotersHoldingsRetrieveResponseTransformer = async (
  data: any
): Promise<DirectoutreachVotersHoldingsRetrieveResponse> => {
  data = holdingResponseSchemaResponseTransformer(data)
  return data
}

const selectedPolicySchemaResponseTransformer = (data: any) => {
  data.create_time = new Date(data.create_time)
  return data
}

const selectedPolicyResponseSchemaResponseTransformer = (data: any) => {
  if (data.selectedPolicy) {
    data.selectedPolicy = selectedPolicySchemaResponseTransformer(data.selectedPolicy)
  }
  return data
}

export const directoutreachVotersSelectedPolicyRetrieveResponseTransformer = async (
  data: any
): Promise<DirectoutreachVotersSelectedPolicyRetrieveResponse> => {
  data = selectedPolicyResponseSchemaResponseTransformer(data)
  return data
}

export const directoutreachVotersSelectedPolicyCreateResponseTransformer = async (
  data: any
): Promise<DirectoutreachVotersSelectedPolicyCreateResponse> => {
  data = selectedPolicyResponseSchemaResponseTransformer(data)
  return data
}

const voterWithHoldingsResponseSchemaResponseTransformer = (data: any) => {
  data.holdings = data.holdings.map((item: any) => holdingSchemaResponseTransformer(item))
  return data
}

export const directoutreachVotersCreateCreateResponseTransformer = async (
  data: any
): Promise<DirectoutreachVotersCreateCreateResponse> => {
  data = voterWithHoldingsResponseSchemaResponseTransformer(data)
  return data
}

const custodyAccountVoterLinkSchemaResponseTransformer = (data: any) => {
  data.create_time = new Date(data.create_time)
  data.update_time = new Date(data.update_time)
  return data
}

const paginatedCustodyAccountVoterLinkListSchemaResponseTransformer = (data: any) => {
  data.results = data.results.map((item: any) => custodyAccountVoterLinkSchemaResponseTransformer(item))
  return data
}

export const directvotingCustodyAccountVoterLinksListResponseTransformer = async (
  data: any
): Promise<DirectvotingCustodyAccountVoterLinksListResponse> => {
  data = paginatedCustodyAccountVoterLinkListSchemaResponseTransformer(data)
  return data
}

export const directvotingCustodyAccountVoterLinksLinkCreateResponseTransformer = async (
  data: any
): Promise<DirectvotingCustodyAccountVoterLinksLinkCreateResponse> => {
  data = custodyAccountVoterLinkSchemaResponseTransformer(data)
  return data
}

const custodyAccountVotingPolicySelectionSchemaResponseTransformer = (data: any) => {
  data.create_time = new Date(data.create_time)
  return data
}

export const directvotingCustodyAccountVotingPolicySelectionsCreateResponseTransformer = async (
  data: any
): Promise<DirectvotingCustodyAccountVotingPolicySelectionsCreateResponse> => {
  data = custodyAccountVotingPolicySelectionSchemaResponseTransformer(data)
  return data
}

export const directvotingCustodyAccountVotingPolicySelectionsRetrieveResponseTransformer = async (
  data: any
): Promise<DirectvotingCustodyAccountVotingPolicySelectionsRetrieveResponse> => {
  data = custodyAccountVotingPolicySelectionSchemaResponseTransformer(data)
  return data
}

export const directvotingCustodyAccountVotingPolicySelectionsPartialUpdateResponseTransformer = async (
  data: any
): Promise<DirectvotingCustodyAccountVotingPolicySelectionsPartialUpdateResponse> => {
  data = custodyAccountVotingPolicySelectionSchemaResponseTransformer(data)
  return data
}

export const directvotingCustodyAccountVotingPolicySelectionsUpdateResponseTransformer = async (
  data: any
): Promise<DirectvotingCustodyAccountVotingPolicySelectionsUpdateResponse> => {
  data = custodyAccountVotingPolicySelectionSchemaResponseTransformer(data)
  return data
}

const paginatedCustodyAccountVotingPolicySelectionListSchemaResponseTransformer = (data: any) => {
  data.results = data.results.map((item: any) => custodyAccountVotingPolicySelectionSchemaResponseTransformer(item))
  return data
}

export const directvotingCustodyAccountVotingPolicySelectionsSearchCreateResponseTransformer = async (
  data: any
): Promise<DirectvotingCustodyAccountVotingPolicySelectionsSearchCreateResponse> => {
  data = paginatedCustodyAccountVotingPolicySelectionListSchemaResponseTransformer(data)
  return data
}

const custodyAccountSchemaResponseTransformer = (data: any) => {
  data.create_time = new Date(data.create_time)
  data.update_time = new Date(data.update_time)
  return data
}

const paginatedCustodyAccountListSchemaResponseTransformer = (data: any) => {
  data.results = data.results.map((item: any) => custodyAccountSchemaResponseTransformer(item))
  return data
}

export const directvotingCustodyAccountsListResponseTransformer = async (
  data: any
): Promise<DirectvotingCustodyAccountsListResponse> => {
  data = paginatedCustodyAccountListSchemaResponseTransformer(data)
  return data
}

export const directvotingCustodyAccountsCreateResponseTransformer = async (
  data: any
): Promise<DirectvotingCustodyAccountsCreateResponse> => {
  data = custodyAccountSchemaResponseTransformer(data)
  return data
}

export const directvotingCustodyAccountsRetrieveResponseTransformer = async (
  data: any
): Promise<DirectvotingCustodyAccountsRetrieveResponse> => {
  data = custodyAccountSchemaResponseTransformer(data)
  return data
}

export const directvotingCustodyAccountsPartialUpdateResponseTransformer = async (
  data: any
): Promise<DirectvotingCustodyAccountsPartialUpdateResponse> => {
  data = custodyAccountSchemaResponseTransformer(data)
  return data
}

export const directvotingCustodyAccountsUpdateResponseTransformer = async (
  data: any
): Promise<DirectvotingCustodyAccountsUpdateResponse> => {
  data = custodyAccountSchemaResponseTransformer(data)
  return data
}

const voterSchemaResponseTransformer = (data: any) => {
  data.create_time = new Date(data.create_time)
  data.update_time = new Date(data.update_time)
  return data
}

const paginatedVoterListSchemaResponseTransformer = (data: any) => {
  data.results = data.results.map((item: any) => voterSchemaResponseTransformer(item))
  return data
}

export const directvotingVotersListResponseTransformer = async (data: any): Promise<DirectvotingVotersListResponse> => {
  data = paginatedVoterListSchemaResponseTransformer(data)
  return data
}

export const directvotingVotersCreateResponseTransformer = async (
  data: any
): Promise<DirectvotingVotersCreateResponse> => {
  data = voterSchemaResponseTransformer(data)
  return data
}

export const directvotingVotersRetrieveResponseTransformer = async (
  data: any
): Promise<DirectvotingVotersRetrieveResponse> => {
  data = voterSchemaResponseTransformer(data)
  return data
}

export const directvotingVotersPartialUpdateResponseTransformer = async (
  data: any
): Promise<DirectvotingVotersPartialUpdateResponse> => {
  data = voterSchemaResponseTransformer(data)
  return data
}

export const directvotingVotersUpdateResponseTransformer = async (
  data: any
): Promise<DirectvotingVotersUpdateResponse> => {
  data = voterSchemaResponseTransformer(data)
  return data
}

const directVoteInstructionSchemaResponseTransformer = (data: any) => {
  data.create_time = new Date(data.create_time)
  return data
}

const castVoteResponseSchemaResponseTransformer = (data: any) => {
  data.instructions = data.instructions.map((item: any) => directVoteInstructionSchemaResponseTransformer(item))
  return data
}

export const directvotingVotersBallotsCastVoteCreateResponseTransformer = async (
  data: any
): Promise<DirectvotingVotersBallotsCastVoteCreateResponse> => {
  data = castVoteResponseSchemaResponseTransformer(data)
  return data
}

const ballotProposalVotingInstructionSchemaResponseTransformer = (data: any) => {
  data.update_time = new Date(data.update_time)
  return data
}

const ballotProposalSchemaResponseTransformer = (data: any) => {
  if (data.voting_instruction) {
    data.voting_instruction = ballotProposalVotingInstructionSchemaResponseTransformer(data.voting_instruction)
  }
  return data
}

const ballotProposalsResponseSchemaResponseTransformer = (data: any) => {
  data.proposals = data.proposals.map((item: any) => ballotProposalSchemaResponseTransformer(item))
  return data
}

export const directvotingVotersBallotsProposalsRetrieveResponseTransformer = async (
  data: any
): Promise<DirectvotingVotersBallotsProposalsRetrieveResponse> => {
  data = ballotProposalsResponseSchemaResponseTransformer(data)
  return data
}

const voterBallotSchemaResponseTransformer = (data: any) => {
  data.available_shares = BigInt(data.available_shares.toString())
  data.vote_deadline = new Date(data.vote_deadline)
  return data
}

const paginatedVoterBallotListSchemaResponseTransformer = (data: any) => {
  data.results = data.results.map((item: any) => voterBallotSchemaResponseTransformer(item))
  return data
}

export const directvotingVotersBallotsSearchCreateResponseTransformer = async (
  data: any
): Promise<DirectvotingVotersBallotsSearchCreateResponse> => {
  data = paginatedVoterBallotListSchemaResponseTransformer(data)
  return data
}

const voterMeetingSchemaResponseTransformer = (data: any) => {
  data.meeting_date = new Date(data.meeting_date)
  data.meeting_deadline = new Date(data.meeting_deadline)
  return data
}

const paginatedVoterMeetingListSchemaResponseTransformer = (data: any) => {
  data.results = data.results.map((item: any) => voterMeetingSchemaResponseTransformer(item))
  return data
}

export const directvotingVotersMeetingsSearchCreateResponseTransformer = async (
  data: any
): Promise<DirectvotingVotersMeetingsSearchCreateResponse> => {
  data = paginatedVoterMeetingListSchemaResponseTransformer(data)
  return data
}

const fundManagerSchemaResponseTransformer = (data: any) => {
  data.create_time = new Date(data.create_time)
  data.update_time = new Date(data.update_time)
  return data
}

export const fundManagerFundManagersCreateResponseTransformer = async (
  data: any
): Promise<FundManagerFundManagersCreateResponse> => {
  data = fundManagerSchemaResponseTransformer(data)
  return data
}

const fundManagerPolicySchemaResponseTransformer = (data: any) => {
  data.update_time = new Date(data.update_time)
  return data
}

const fundManagerPolicyListResponseSchemaResponseTransformer = (data: any) => {
  data.policies = data.policies.map((item: any) => fundManagerPolicySchemaResponseTransformer(item))
  return data
}

export const fundManagerFundManagersPoliciesRetrieveResponseTransformer = async (
  data: any
): Promise<FundManagerFundManagersPoliciesRetrieveResponse> => {
  data = fundManagerPolicyListResponseSchemaResponseTransformer(data)
  return data
}

export const fundManagerFundManagersPoliciesCreateResponseTransformer = async (
  data: any
): Promise<FundManagerFundManagersPoliciesCreateResponse> => {
  data = fundManagerPolicySchemaResponseTransformer(data)
  return data
}

export const fundManagerFundManagersRetrieveResponseTransformer = async (
  data: any
): Promise<FundManagerFundManagersRetrieveResponse> => {
  data = fundManagerSchemaResponseTransformer(data)
  return data
}

export const fundManagerFundManagersUpdateResponseTransformer = async (
  data: any
): Promise<FundManagerFundManagersUpdateResponse> => {
  data = fundManagerSchemaResponseTransformer(data)
  return data
}

const paginatedFundManagerListSchemaResponseTransformer = (data: any) => {
  data.results = data.results.map((item: any) => fundManagerSchemaResponseTransformer(item))
  return data
}

export const fundManagerFundManagersSearchCreateResponseTransformer = async (
  data: any
): Promise<FundManagerFundManagersSearchCreateResponse> => {
  data = paginatedFundManagerListSchemaResponseTransformer(data)
  return data
}

const fundVariantSchemaResponseTransformer = (data: any) => {
  data.create_time = new Date(data.create_time)
  data.update_time = new Date(data.update_time)
  return data
}

export const fundManagerFundVariantsCreateResponseTransformer = async (
  data: any
): Promise<FundManagerFundVariantsCreateResponse> => {
  data = fundVariantSchemaResponseTransformer(data)
  return data
}

export const fundManagerFundVariantsRetrieveResponseTransformer = async (
  data: any
): Promise<FundManagerFundVariantsRetrieveResponse> => {
  data = fundVariantSchemaResponseTransformer(data)
  return data
}

export const fundManagerFundVariantsUpdateResponseTransformer = async (
  data: any
): Promise<FundManagerFundVariantsUpdateResponse> => {
  data = fundVariantSchemaResponseTransformer(data)
  return data
}

const paginatedFundVariantListSchemaResponseTransformer = (data: any) => {
  data.results = data.results.map((item: any) => fundVariantSchemaResponseTransformer(item))
  return data
}

export const fundManagerFundVariantsSearchCreateResponseTransformer = async (
  data: any
): Promise<FundManagerFundVariantsSearchCreateResponse> => {
  data = paginatedFundVariantListSchemaResponseTransformer(data)
  return data
}

const fundSchemaResponseTransformer = (data: any) => {
  data.create_time = new Date(data.create_time)
  data.update_time = new Date(data.update_time)
  return data
}

export const fundManagerFundsCreateResponseTransformer = async (data: any): Promise<FundManagerFundsCreateResponse> => {
  data = fundSchemaResponseTransformer(data)
  return data
}

const fundQuantificationSnapshotSchemaResponseTransformer = (data: any) => {
  data.valid_time = new Date(data.valid_time)
  data.create_time = new Date(data.create_time)
  return data
}

export const fundManagerFundsQuantificationSnapshotsCreateResponseTransformer = async (
  data: any
): Promise<FundManagerFundsQuantificationSnapshotsCreateResponse> => {
  data = fundQuantificationSnapshotSchemaResponseTransformer(data)
  return data
}

export const fundManagerFundsRetrieveResponseTransformer = async (
  data: any
): Promise<FundManagerFundsRetrieveResponse> => {
  data = fundSchemaResponseTransformer(data)
  return data
}

export const fundManagerFundsUpdateResponseTransformer = async (data: any): Promise<FundManagerFundsUpdateResponse> => {
  data = fundSchemaResponseTransformer(data)
  return data
}

const paginatedFundListSchemaResponseTransformer = (data: any) => {
  data.results = data.results.map((item: any) => fundSchemaResponseTransformer(item))
  return data
}

export const fundManagerFundsSearchCreateResponseTransformer = async (
  data: any
): Promise<FundManagerFundsSearchCreateResponse> => {
  data = paginatedFundListSchemaResponseTransformer(data)
  return data
}

const providerSchemaResponseTransformer = (data: any) => {
  data.create_time = new Date(data.create_time)
  data.update_time = new Date(data.update_time)
  return data
}

const paginatedProviderListSchemaResponseTransformer = (data: any) => {
  data.results = data.results.map((item: any) => providerSchemaResponseTransformer(item))
  return data
}

export const fundManagerProvidersListResponseTransformer = async (
  data: any
): Promise<FundManagerProvidersListResponse> => {
  data = paginatedProviderListSchemaResponseTransformer(data)
  return data
}

export const fundManagerProvidersCreateResponseTransformer = async (
  data: any
): Promise<FundManagerProvidersCreateResponse> => {
  data = providerSchemaResponseTransformer(data)
  return data
}

export const fundManagerProvidersRetrieveResponseTransformer = async (
  data: any
): Promise<FundManagerProvidersRetrieveResponse> => {
  data = providerSchemaResponseTransformer(data)
  return data
}

export const fundManagerProvidersUpdateResponseTransformer = async (
  data: any
): Promise<FundManagerProvidersUpdateResponse> => {
  data = providerSchemaResponseTransformer(data)
  return data
}

const paginatedFundQuantificationSnapshotListSchemaResponseTransformer = (data: any) => {
  data.results = data.results.map((item: any) => fundQuantificationSnapshotSchemaResponseTransformer(item))
  return data
}

export const fundManagerQuantificationSnapshotsSearchCreateResponseTransformer = async (
  data: any
): Promise<FundManagerQuantificationSnapshotsSearchCreateResponse> => {
  data = paginatedFundQuantificationSnapshotListSchemaResponseTransformer(data)
  return data
}

const meetingSchemaResponseTransformer = (data: any) => {
  data.meeting_date = new Date(data.meeting_date)
  data.action_deadline = new Date(data.action_deadline)
  return data
}

const paginatedMeetingListSchemaResponseTransformer = (data: any) => {
  data.results = data.results.map((item: any) => meetingSchemaResponseTransformer(item))
  return data
}

export const institutionalMeetingsearchListResponseTransformer = async (
  data: any
): Promise<InstitutionalMeetingsearchListResponse> => {
  data = paginatedMeetingListSchemaResponseTransformer(data)
  return data
}

const deadlinesSchemaResponseTransformer = (data: any) => {
  data.investor_voting_deadline = new Date(data.investor_voting_deadline)
  data.vote_allocation_time = new Date(data.vote_allocation_time)
  data.vote_allocation_window_start_time = new Date(data.vote_allocation_window_start_time)
  data.created_at = new Date(data.created_at)
  return data
}

const ballotSchemaResponseTransformer = (data: any) => {
  data.create_time = new Date(data.create_time)
  data.version_create_time = new Date(data.version_create_time)
  if (data.cancel_time) {
    data.cancel_time = new Date(data.cancel_time)
  }
  data.eligible_shares = BigInt(data.eligible_shares.toString())
  data.submission_deadline = new Date(data.submission_deadline)
  data.valid_time = new Date(data.valid_time)
  if (data.deadlines) {
    data.deadlines = deadlinesSchemaResponseTransformer(data.deadlines)
  }
  return data
}

const paginatedBallotListSchemaResponseTransformer = (data: any) => {
  data.results = data.results.map((item: any) => ballotSchemaResponseTransformer(item))
  return data
}

export const proxyIntermediaryBallotsVersionsListResponseTransformer = async (
  data: any
): Promise<ProxyIntermediaryBallotsVersionsListResponse> => {
  data = paginatedBallotListSchemaResponseTransformer(data)
  return data
}

const ballotListResponseSchemaResponseTransformer = (data: any) => {
  data.ballots = data.ballots.map((item: any) => ballotSchemaResponseTransformer(item))
  return data
}

export const proxyIntermediaryBallotsFetchByVersionIdsCreateResponseTransformer = async (
  data: any
): Promise<ProxyIntermediaryBallotsFetchByVersionIdsCreateResponse> => {
  data = ballotListResponseSchemaResponseTransformer(data)
  return data
}

export const proxyIntermediaryBallotsSearchCreateResponseTransformer = async (
  data: any
): Promise<ProxyIntermediaryBallotsSearchCreateResponse> => {
  data = paginatedBallotListSchemaResponseTransformer(data)
  return data
}

const upsertResponseSchemaResponseTransformer = (data: any) => {
  data.ballot = ballotSchemaResponseTransformer(data.ballot)
  return data
}

export const proxyIntermediaryBallotsUpsertCreateResponseTransformer = async (
  data: any
): Promise<ProxyIntermediaryBallotsUpsertCreateResponse> => {
  data = upsertResponseSchemaResponseTransformer(data)
  return data
}

const proxyIntermediaryProposalSchemaResponseTransformer = (data: any) => {
  data.create_time = new Date(data.create_time)
  return data
}

const createProposalsResponseSchemaResponseTransformer = (data: any) => {
  data.proposals = data.proposals.map((item: any) => proxyIntermediaryProposalSchemaResponseTransformer(item))
  return data
}

export const proxyIntermediaryProposalsCreateCreateResponseTransformer = async (
  data: any
): Promise<ProxyIntermediaryProposalsCreateCreateResponse> => {
  data = createProposalsResponseSchemaResponseTransformer(data)
  return data
}

const paginatedProxyIntermediaryProposalListSchemaResponseTransformer = (data: any) => {
  data.results = data.results.map((item: any) => proxyIntermediaryProposalSchemaResponseTransformer(item))
  return data
}

export const proxyIntermediaryProposalsSearchCreateResponseTransformer = async (
  data: any
): Promise<ProxyIntermediaryProposalsSearchCreateResponse> => {
  data = paginatedProxyIntermediaryProposalListSchemaResponseTransformer(data)
  return data
}

const proxyIntermediarySchemaResponseTransformer = (data: any) => {
  data.create_time = new Date(data.create_time)
  return data
}

const paginatedProxyIntermediaryListSchemaResponseTransformer = (data: any) => {
  data.results = data.results.map((item: any) => proxyIntermediarySchemaResponseTransformer(item))
  return data
}

export const proxyIntermediaryProxyIntermediariesSearchCreateResponseTransformer = async (
  data: any
): Promise<ProxyIntermediaryProxyIntermediariesSearchCreateResponse> => {
  data = paginatedProxyIntermediaryListSchemaResponseTransformer(data)
  return data
}

const proxyIntermediaryMeetingAuditEventSchemaResponseTransformer = (data: any) => {
  data.create_time = new Date(data.create_time)
  return data
}

const paginatedProxyIntermediaryMeetingAuditEventListSchemaResponseTransformer = (data: any) => {
  data.results = data.results.map((item: any) => proxyIntermediaryMeetingAuditEventSchemaResponseTransformer(item))
  return data
}

export const proxyIntermediaryProxyIntermediaryMeetingsAuditEventsSearchCreateResponseTransformer = async (
  data: any
): Promise<ProxyIntermediaryProxyIntermediaryMeetingsAuditEventsSearchCreateResponse> => {
  data = paginatedProxyIntermediaryMeetingAuditEventListSchemaResponseTransformer(data)
  return data
}

const proxyIntermediaryMeetingSchemaResponseTransformer = (data: any) => {
  data.meeting_time = new Date(data.meeting_time)
  data.submission_deadline = new Date(data.submission_deadline)
  if (data.record_date) {
    data.record_date = new Date(data.record_date)
  }
  data.create_time = new Date(data.create_time)
  if (data.cancel_time) {
    data.cancel_time = new Date(data.cancel_time)
  }
  data.valid_time = new Date(data.valid_time)
  return data
}

const proxyIntermediaryMeetingBatchCancelResponseSchemaResponseTransformer = (data: any) => {
  data.proxy_intermediary_meetings = data.proxy_intermediary_meetings.map((item: any) =>
    proxyIntermediaryMeetingSchemaResponseTransformer(item)
  )
  return data
}

export const proxyIntermediaryProxyIntermediaryMeetingsCancelCreateResponseTransformer = async (
  data: any
): Promise<ProxyIntermediaryProxyIntermediaryMeetingsCancelCreateResponse> => {
  data = proxyIntermediaryMeetingBatchCancelResponseSchemaResponseTransformer(data)
  return data
}

const proxyIntermediaryMeetingResponseSchemaResponseTransformer = (data: any) => {
  data.proxy_intermediary_meeting = proxyIntermediaryMeetingSchemaResponseTransformer(data.proxy_intermediary_meeting)
  return data
}

export const proxyIntermediaryProxyIntermediaryMeetingsLinkTransparencyGeneralMeetingCreateResponseTransformer = async (
  data: any
): Promise<ProxyIntermediaryProxyIntermediaryMeetingsLinkTransparencyGeneralMeetingCreateResponse> => {
  data = proxyIntermediaryMeetingResponseSchemaResponseTransformer(data)
  return data
}

const paginatedProxyIntermediaryMeetingListSchemaResponseTransformer = (data: any) => {
  data.results = data.results.map((item: any) => proxyIntermediaryMeetingSchemaResponseTransformer(item))
  return data
}

export const proxyIntermediaryProxyIntermediaryMeetingsSearchCreateResponseTransformer = async (
  data: any
): Promise<ProxyIntermediaryProxyIntermediaryMeetingsSearchCreateResponse> => {
  data = paginatedProxyIntermediaryMeetingListSchemaResponseTransformer(data)
  return data
}

export const proxyIntermediaryProxyIntermediaryMeetingsUnlinkTransparencyGeneralMeetingCreateResponseTransformer =
  async (
    data: any
  ): Promise<ProxyIntermediaryProxyIntermediaryMeetingsUnlinkTransparencyGeneralMeetingCreateResponse> => {
    data = proxyIntermediaryMeetingResponseSchemaResponseTransformer(data)
    return data
  }

const proxyIntermediaryMeetingUpsertResponseSchemaResponseTransformer = (data: any) => {
  data.proxy_intermediary_meeting = proxyIntermediaryMeetingSchemaResponseTransformer(data.proxy_intermediary_meeting)
  return data
}

export const proxyIntermediaryProxyIntermediaryMeetingsUpsertCreateResponseTransformer = async (
  data: any
): Promise<ProxyIntermediaryProxyIntermediaryMeetingsUpsertCreateResponse> => {
  data = proxyIntermediaryMeetingUpsertResponseSchemaResponseTransformer(data)
  return data
}

const ballotEntitlementSchemaResponseTransformer = (data: any) => {
  data.create_time = new Date(data.create_time)
  data.update_time = new Date(data.update_time)
  if (data.invalid_time) {
    data.invalid_time = new Date(data.invalid_time)
  }
  return data
}

const paginatedBallotEntitlementListSchemaResponseTransformer = (data: any) => {
  data.results = data.results.map((item: any) => ballotEntitlementSchemaResponseTransformer(item))
  return data
}

export const proxyvotingEntitlementsListResponseTransformer = async (
  data: any
): Promise<ProxyvotingEntitlementsListResponse> => {
  data = paginatedBallotEntitlementListSchemaResponseTransformer(data)
  return data
}

const fundManagerPolicySiiSchemaResponseTransformer = (data: any) => {
  data.create_time = new Date(data.create_time)
  if (data.delete_time) {
    data.delete_time = new Date(data.delete_time)
  }
  data.valid_from = new Date(data.valid_from)
  if (data.valid_to) {
    data.valid_to = new Date(data.valid_to)
  }
  return data
}

const fundManagerPolicySiiResponseSchemaResponseTransformer = (data: any) => {
  data.items = data.items.map((item: any) => fundManagerPolicySiiSchemaResponseTransformer(item))
  return data
}

export const proxyvotingFundManagerPolicySupportedIssuedInstrumentsCreateResponseTransformer = async (
  data: any
): Promise<ProxyvotingFundManagerPolicySupportedIssuedInstrumentsCreateResponse> => {
  data = fundManagerPolicySiiResponseSchemaResponseTransformer(data)
  return data
}

const paginatedFundManagerPolicySiiListSchemaResponseTransformer = (data: any) => {
  data.results = data.results.map((item: any) => fundManagerPolicySiiSchemaResponseTransformer(item))
  return data
}

export const proxyvotingFundManagerPolicySupportedIssuedInstrumentsSearchCreateResponseTransformer = async (
  data: any
): Promise<ProxyvotingFundManagerPolicySupportedIssuedInstrumentsSearchCreateResponse> => {
  data = paginatedFundManagerPolicySiiListSchemaResponseTransformer(data)
  return data
}

const fundManagerSupportedVotingPolicyHistoricalSchemaResponseTransformer = (data: any) => {
  data.create_time = new Date(data.create_time)
  data.update_time = new Date(data.update_time)
  if (data.history_date) {
    data.history_date = new Date(data.history_date)
  }
  return data
}

const paginatedFundManagerSupportedVotingPolicyHistoricalListSchemaResponseTransformer = (data: any) => {
  data.results = data.results.map((item: any) =>
    fundManagerSupportedVotingPolicyHistoricalSchemaResponseTransformer(item)
  )
  return data
}

export const proxyvotingFundManagerSupportedPoliciesListResponseTransformer = async (
  data: any
): Promise<ProxyvotingFundManagerSupportedPoliciesListResponse> => {
  data = paginatedFundManagerSupportedVotingPolicyHistoricalListSchemaResponseTransformer(data)
  return data
}

const fundManagerSupportedVotingPolicySchemaResponseTransformer = (data: any) => {
  data.create_time = new Date(data.create_time)
  data.update_time = new Date(data.update_time)
  return data
}

const fundManagerSupportedVotingPolicyBatchUpsertResponseSchemaResponseTransformer = (data: any) => {
  data.policies = data.policies.map((item: any) => fundManagerSupportedVotingPolicySchemaResponseTransformer(item))
  return data
}

export const proxyvotingFundManagerSupportedPoliciesCreateResponseTransformer = async (
  data: any
): Promise<ProxyvotingFundManagerSupportedPoliciesCreateResponse> => {
  data = fundManagerSupportedVotingPolicyBatchUpsertResponseSchemaResponseTransformer(data)
  return data
}

const componentDiffSchemaResponseTransformer = (data: any) => {
  data.start_date = new Date(data.start_date)
  return data
}

const compositionDifferenceResponseSchemaResponseTransformer = (data: any) => {
  data.components = data.components.map((item: any) => componentDiffSchemaResponseTransformer(item))
  return data
}

export const proxyvotingInvestorCompositionsDifferenceListResponseTransformer = async (
  data: any
): Promise<ProxyvotingInvestorCompositionsDifferenceListResponse> => {
  data = data.map((item: any) => compositionDifferenceResponseSchemaResponseTransformer(item))
  return data
}

const investorRulesEngineSchemaResponseTransformer = (data: any) => {
  data.created_at = new Date(data.created_at)
  data.updated_at = new Date(data.updated_at)
  return data
}

export const proxyvotingInvestorCompositionsRulesEngineRetrieveResponseTransformer = async (
  data: any
): Promise<ProxyvotingInvestorCompositionsRulesEngineRetrieveResponse> => {
  data = investorRulesEngineSchemaResponseTransformer(data)
  return data
}

export const proxyvotingInvestorCompositionsRulesEngineUpdateResponseTransformer = async (
  data: any
): Promise<ProxyvotingInvestorCompositionsRulesEngineUpdateResponse> => {
  data = investorRulesEngineSchemaResponseTransformer(data)
  return data
}

const investorPolicySiiSchemaResponseTransformer = (data: any) => {
  data.create_time = new Date(data.create_time)
  if (data.delete_time) {
    data.delete_time = new Date(data.delete_time)
  }
  data.valid_from = new Date(data.valid_from)
  if (data.valid_to) {
    data.valid_to = new Date(data.valid_to)
  }
  return data
}

const investorPolicySiiResponseSchemaResponseTransformer = (data: any) => {
  data.items = data.items.map((item: any) => investorPolicySiiSchemaResponseTransformer(item))
  return data
}

export const proxyvotingInvestorPolicySupportedIssuedInstrumentsCreateResponseTransformer = async (
  data: any
): Promise<ProxyvotingInvestorPolicySupportedIssuedInstrumentsCreateResponse> => {
  data = investorPolicySiiResponseSchemaResponseTransformer(data)
  return data
}

const paginatedInvestorPolicySiiListSchemaResponseTransformer = (data: any) => {
  data.results = data.results.map((item: any) => investorPolicySiiSchemaResponseTransformer(item))
  return data
}

export const proxyvotingInvestorPolicySupportedIssuedInstrumentsSearchCreateResponseTransformer = async (
  data: any
): Promise<ProxyvotingInvestorPolicySupportedIssuedInstrumentsSearchCreateResponse> => {
  data = paginatedInvestorPolicySiiListSchemaResponseTransformer(data)
  return data
}

const investorSupportedIssuedInstrumentSchemaResponseTransformer = (data: any) => {
  data.create_time = new Date(data.create_time)
  if (data.delete_time) {
    data.delete_time = new Date(data.delete_time)
  }
  data.valid_from = new Date(data.valid_from)
  if (data.valid_to) {
    data.valid_to = new Date(data.valid_to)
  }
  return data
}

const investorSiiResponseSchemaResponseTransformer = (data: any) => {
  data.items = data.items.map((item: any) => investorSupportedIssuedInstrumentSchemaResponseTransformer(item))
  return data
}

export const proxyvotingInvestorSupportedIssuedInstrumentsCreateResponseTransformer = async (
  data: any
): Promise<ProxyvotingInvestorSupportedIssuedInstrumentsCreateResponse> => {
  data = investorSiiResponseSchemaResponseTransformer(data)
  return data
}

const paginatedInvestorSupportedIssuedInstrumentListSchemaResponseTransformer = (data: any) => {
  data.results = data.results.map((item: any) => investorSupportedIssuedInstrumentSchemaResponseTransformer(item))
  return data
}

export const proxyvotingInvestorSupportedIssuedInstrumentsSearchCreateResponseTransformer = async (
  data: any
): Promise<ProxyvotingInvestorSupportedIssuedInstrumentsSearchCreateResponse> => {
  data = paginatedInvestorSupportedIssuedInstrumentListSchemaResponseTransformer(data)
  return data
}

const meetingBallotSourceSchemaResponseTransformer = (data: any) => {
  data.create_time = new Date(data.create_time)
  data.update_time = new Date(data.update_time)
  if (data.invalid_time) {
    data.invalid_time = new Date(data.invalid_time)
  }
  return data
}

const paginatedMeetingBallotSourceListSchemaResponseTransformer = (data: any) => {
  data.results = data.results.map((item: any) => meetingBallotSourceSchemaResponseTransformer(item))
  return data
}

export const proxyvotingMeetingBallotSourcesListResponseTransformer = async (
  data: any
): Promise<ProxyvotingMeetingBallotSourcesListResponse> => {
  data = paginatedMeetingBallotSourceListSchemaResponseTransformer(data)
  return data
}

const meetingBallotSchemaResponseTransformer = (data: any) => {
  data.earliest_voting_deadline = new Date(data.earliest_voting_deadline)
  data.latest_voting_deadline = new Date(data.latest_voting_deadline)
  data.create_time = new Date(data.create_time)
  data.update_time = new Date(data.update_time)
  if (data.complete_time) {
    data.complete_time = new Date(data.complete_time)
  }
  return data
}

const paginatedMeetingBallotListSchemaResponseTransformer = (data: any) => {
  data.results = data.results.map((item: any) => meetingBallotSchemaResponseTransformer(item))
  return data
}

export const proxyvotingMeetingBallotsListResponseTransformer = async (
  data: any
): Promise<ProxyvotingMeetingBallotsListResponse> => {
  data = paginatedMeetingBallotListSchemaResponseTransformer(data)
  return data
}

const piBallotSearchSchemaResponseTransformer = (data: any) => {
  data.vote_deadline = new Date(data.vote_deadline)
  return data
}

const paginatedPiBallotSearchListSchemaResponseTransformer = (data: any) => {
  data.results = data.results.map((item: any) => piBallotSearchSchemaResponseTransformer(item))
  return data
}

export const proxyvotingPiballotsFilterListResponseTransformer = async (
  data: any
): Promise<ProxyvotingPiballotsFilterListResponse> => {
  data = paginatedPiBallotSearchListSchemaResponseTransformer(data)
  return data
}

const piMeetingSearchSchemaResponseTransformer = (data: any) => {
  data.meeting_time = new Date(data.meeting_time)
  data.submission_deadline = new Date(data.submission_deadline)
  if (data.record_date) {
    data.record_date = new Date(data.record_date)
  }
  if (data.cancel_time) {
    data.cancel_time = new Date(data.cancel_time)
  }
  data.meeting_create_time = new Date(data.meeting_create_time)
  if (data.latest_valid_to_sii) {
    data.latest_valid_to_sii = new Date(data.latest_valid_to_sii)
  }
  if (data.earliest_ballot_submission_deadline) {
    data.earliest_ballot_submission_deadline = new Date(data.earliest_ballot_submission_deadline)
  }
  return data
}

const paginatedPiMeetingSearchListSchemaResponseTransformer = (data: any) => {
  data.results = data.results.map((item: any) => piMeetingSearchSchemaResponseTransformer(item))
  return data
}

export const proxyvotingPimeetingsFilterListResponseTransformer = async (
  data: any
): Promise<ProxyvotingPimeetingsFilterListResponse> => {
  data = paginatedPiMeetingSearchListSchemaResponseTransformer(data)
  return data
}

const rulesEngineDefinitionSchemaResponseTransformer = (data: any) => {
  data.valid_from = new Date(data.valid_from)
  data.create_time = new Date(data.create_time)
  data.update_time = new Date(data.update_time)
  return data
}

const paginatedRulesEngineDefinitionListSchemaResponseTransformer = (data: any) => {
  data.results = data.results.map((item: any) => rulesEngineDefinitionSchemaResponseTransformer(item))
  return data
}

export const proxyvotingRulesEngineDefinitionsListResponseTransformer = async (
  data: any
): Promise<ProxyvotingRulesEngineDefinitionsListResponse> => {
  data = paginatedRulesEngineDefinitionListSchemaResponseTransformer(data)
  return data
}

export const proxyvotingRulesEngineDefinitionsCreateResponseTransformer = async (
  data: any
): Promise<ProxyvotingRulesEngineDefinitionsCreateResponse> => {
  data = rulesEngineDefinitionSchemaResponseTransformer(data)
  return data
}

const rulesEngineRuleSchemaResponseTransformer = (data: any) => {
  data.create_time = new Date(data.create_time)
  data.update_time = new Date(data.update_time)
  return data
}

const paginatedRulesEngineRuleListSchemaResponseTransformer = (data: any) => {
  data.results = data.results.map((item: any) => rulesEngineRuleSchemaResponseTransformer(item))
  return data
}

export const proxyvotingRulesEngineDefinitionsRulesListResponseTransformer = async (
  data: any
): Promise<ProxyvotingRulesEngineDefinitionsRulesListResponse> => {
  data = paginatedRulesEngineRuleListSchemaResponseTransformer(data)
  return data
}

export const proxyvotingRulesEngineDefinitionsRulesCreateResponseTransformer = async (
  data: any
): Promise<ProxyvotingRulesEngineDefinitionsRulesCreateResponse> => {
  data = rulesEngineRuleSchemaResponseTransformer(data)
  return data
}

export const proxyvotingRulesEngineDefinitionsRulesUpdateResponseTransformer = async (
  data: any
): Promise<ProxyvotingRulesEngineDefinitionsRulesUpdateResponse> => {
  data = rulesEngineRuleSchemaResponseTransformer(data)
  return data
}

export const proxyvotingRulesEngineDefinitionsRetrieveResponseTransformer = async (
  data: any
): Promise<ProxyvotingRulesEngineDefinitionsRetrieveResponse> => {
  data = rulesEngineDefinitionSchemaResponseTransformer(data)
  return data
}

const splitVoteInstructionProposalOverwriteSchemaResponseTransformer = (data: any) => {
  data.create_time = new Date(data.create_time)
  if (data.delete_time) {
    data.delete_time = new Date(data.delete_time)
  }
  return data
}

export const proxyvotingSviProposalOverwriteCreateResponseTransformer = async (
  data: any
): Promise<ProxyvotingSviProposalOverwriteCreateResponse> => {
  data = splitVoteInstructionProposalOverwriteSchemaResponseTransformer(data)
  return data
}

const auditEventSchemaResponseTransformer = (data: any) => {
  data.create_time = new Date(data.create_time)
  return data
}

const paginatedAuditEventListSchemaResponseTransformer = (data: any) => {
  data.results = data.results.map((item: any) => auditEventSchemaResponseTransformer(item))
  return data
}

export const transparencyAuditEventsSearchCreateResponseTransformer = async (
  data: any
): Promise<TransparencyAuditEventsSearchCreateResponse> => {
  data = paginatedAuditEventListSchemaResponseTransformer(data)
  return data
}

const externalMeetingIdSchemaResponseTransformer = (data: any) => {
  data.create_time = new Date(data.create_time)
  return data
}

export const transparencyExternalMeetingIdsCreateResponseTransformer = async (
  data: any
): Promise<TransparencyExternalMeetingIdsCreateResponse> => {
  data = externalMeetingIdSchemaResponseTransformer(data)
  return data
}

const proxySubmissionSchemaResponseTransformer = (data: any) => {
  if (data.proxy_edge_deadline) {
    data.proxy_edge_deadline = new Date(data.proxy_edge_deadline)
  }
  return data
}

const generalMeetingSchemaResponseTransformer = (data: any) => {
  data.meeting_date = new Date(data.meeting_date)
  data.create_time = new Date(data.create_time)
  data.update_time = new Date(data.update_time)
  if (data.invalid_time) {
    data.invalid_time = new Date(data.invalid_time)
  }
  if (data.announcement_time) {
    data.announcement_time = new Date(data.announcement_time)
  }
  if (data.record_date) {
    data.record_date = new Date(data.record_date)
  }
  if (data.edi_record_date) {
    data.edi_record_date = new Date(data.edi_record_date)
  }
  if (data.voting_enabled_time) {
    data.voting_enabled_time = new Date(data.voting_enabled_time)
  }
  if (data.disable_edi_agenda_pipeline_updates_time) {
    data.disable_edi_agenda_pipeline_updates_time = new Date(data.disable_edi_agenda_pipeline_updates_time)
  }
  if (data.proxy_submission) {
    data.proxy_submission = proxySubmissionSchemaResponseTransformer(data.proxy_submission)
  }
  return data
}

export const transparencyGeneralMeetingsCreateResponseTransformer = async (
  data: any
): Promise<TransparencyGeneralMeetingsCreateResponse> => {
  data = generalMeetingSchemaResponseTransformer(data)
  return data
}

export const transparencyGeneralMeetingsRetrieveResponseTransformer = async (
  data: any
): Promise<TransparencyGeneralMeetingsRetrieveResponse> => {
  data = generalMeetingSchemaResponseTransformer(data)
  return data
}

export const transparencyGeneralMeetingsPartialUpdateResponseTransformer = async (
  data: any
): Promise<TransparencyGeneralMeetingsPartialUpdateResponse> => {
  data = generalMeetingSchemaResponseTransformer(data)
  return data
}

const paginatedGeneralMeetingListSchemaResponseTransformer = (data: any) => {
  data.results = data.results.map((item: any) => generalMeetingSchemaResponseTransformer(item))
  return data
}

export const transparencyGeneralMeetingsSearchCreateResponseTransformer = async (
  data: any
): Promise<TransparencyGeneralMeetingsSearchCreateResponse> => {
  data = paginatedGeneralMeetingListSchemaResponseTransformer(data)
  return data
}

const organizationSchemaResponseTransformer = (data: any) => {
  data.create_time = new Date(data.create_time)
  data.update_time = new Date(data.update_time)
  return data
}

export const transparencyOrganizationsCreateResponseTransformer = async (
  data: any
): Promise<TransparencyOrganizationsCreateResponse> => {
  data = organizationSchemaResponseTransformer(data)
  return data
}

export const transparencyOrganizationsRetrieveResponseTransformer = async (
  data: any
): Promise<TransparencyOrganizationsRetrieveResponse> => {
  data = organizationSchemaResponseTransformer(data)
  return data
}

export const transparencyOrganizationsPartialUpdateResponseTransformer = async (
  data: any
): Promise<TransparencyOrganizationsPartialUpdateResponse> => {
  data = organizationSchemaResponseTransformer(data)
  return data
}

export const transparencyOrganizationsUpdateResponseTransformer = async (
  data: any
): Promise<TransparencyOrganizationsUpdateResponse> => {
  data = organizationSchemaResponseTransformer(data)
  return data
}

export const transparencyOrganizationsLogoCreateResponseTransformer = async (
  data: any
): Promise<TransparencyOrganizationsLogoCreateResponse> => {
  data = organizationSchemaResponseTransformer(data)
  return data
}

const proposalVotesSchemaResponseTransformer = (data: any) => {
  if (data.for_votes) {
    data.for_votes = BigInt(data.for_votes.toString())
  }
  if (data.against_votes) {
    data.against_votes = BigInt(data.against_votes.toString())
  }
  if (data.abstention_votes) {
    data.abstention_votes = BigInt(data.abstention_votes.toString())
  }
  if (data.broker_non_votes) {
    data.broker_non_votes = BigInt(data.broker_non_votes.toString())
  }
  if (data.withheld_votes) {
    data.withheld_votes = BigInt(data.withheld_votes.toString())
  }
  if (data.one_year_votes) {
    data.one_year_votes = BigInt(data.one_year_votes.toString())
  }
  if (data.two_years_votes) {
    data.two_years_votes = BigInt(data.two_years_votes.toString())
  }
  if (data.three_years_votes) {
    data.three_years_votes = BigInt(data.three_years_votes.toString())
  }
  return data
}

const proposalOutcomeSchemaResponseTransformer = (data: any) => {
  if (data.votes) {
    data.votes = proposalVotesSchemaResponseTransformer(data.votes)
  }
  data.create_time = new Date(data.create_time)
  return data
}

const proposalSchemaResponseTransformer = (data: any) => {
  if (data.outcome) {
    data.outcome = proposalOutcomeSchemaResponseTransformer(data.outcome)
  }
  if (data.withdraw_time) {
    data.withdraw_time = new Date(data.withdraw_time)
  }
  data.create_time = new Date(data.create_time)
  data.update_time = new Date(data.update_time)
  if (data.delete_time) {
    data.delete_time = new Date(data.delete_time)
  }
  return data
}

export const transparencyOrganizationsGeneralMeetingsProposalsCreateResponseTransformer = async (
  data: any
): Promise<TransparencyOrganizationsGeneralMeetingsProposalsCreateResponse> => {
  data = proposalSchemaResponseTransformer(data)
  return data
}

export const transparencyOrganizationsGeneralMeetingsProposalsRetrieveResponseTransformer = async (
  data: any
): Promise<TransparencyOrganizationsGeneralMeetingsProposalsRetrieveResponse> => {
  data = proposalSchemaResponseTransformer(data)
  return data
}

export const transparencyOrganizationsGeneralMeetingsProposalsPartialUpdateResponseTransformer = async (
  data: any
): Promise<TransparencyOrganizationsGeneralMeetingsProposalsPartialUpdateResponse> => {
  data = proposalSchemaResponseTransformer(data)
  return data
}

export const transparencyOrganizationsGeneralMeetingsProposalsUpdateResponseTransformer = async (
  data: any
): Promise<TransparencyOrganizationsGeneralMeetingsProposalsUpdateResponse> => {
  data = proposalSchemaResponseTransformer(data)
  return data
}

const paginatedProposalListSchemaResponseTransformer = (data: any) => {
  data.results = data.results.map((item: any) => proposalSchemaResponseTransformer(item))
  return data
}

export const transparencyOrganizationsGeneralMeetingsProposalsSearchCreateResponseTransformer = async (
  data: any
): Promise<TransparencyOrganizationsGeneralMeetingsProposalsSearchCreateResponse> => {
  data = paginatedProposalListSchemaResponseTransformer(data)
  return data
}

export const transparencyOrganizationsGetByIdentifierCreateResponseTransformer = async (
  data: any
): Promise<TransparencyOrganizationsGetByIdentifierCreateResponse> => {
  data = organizationSchemaResponseTransformer(data)
  return data
}

const paginatedOrganizationListSchemaResponseTransformer = (data: any) => {
  data.results = data.results.map((item: any) => organizationSchemaResponseTransformer(item))
  return data
}

export const transparencyOrganizationsSearchCreateResponseTransformer = async (
  data: any
): Promise<TransparencyOrganizationsSearchCreateResponse> => {
  data = paginatedOrganizationListSchemaResponseTransformer(data)
  return data
}

export const transparencyProposalsFetchCreateResponseTransformer = async (
  data: any
): Promise<TransparencyProposalsFetchCreateResponse> => {
  data = paginatedProposalListSchemaResponseTransformer(data)
  return data
}

const publicSecurityIdSchemaResponseTransformer = (data: any) => {
  data.create_time = new Date(data.create_time)
  return data
}

const paginatedPublicSecurityIdListSchemaResponseTransformer = (data: any) => {
  data.results = data.results.map((item: any) => publicSecurityIdSchemaResponseTransformer(item))
  return data
}

export const transparencyPublicSecurityIdsSearchCreateResponseTransformer = async (
  data: any
): Promise<TransparencyPublicSecurityIdsSearchCreateResponse> => {
  data = paginatedPublicSecurityIdListSchemaResponseTransformer(data)
  return data
}

export const votingOperationsPiballotsFilterListResponseTransformer = async (
  data: any
): Promise<VotingOperationsPiballotsFilterListResponse> => {
  data = paginatedPiBallotSearchListSchemaResponseTransformer(data)
  return data
}

export const votingOperationsPimeetingsFilterListResponseTransformer = async (
  data: any
): Promise<VotingOperationsPimeetingsFilterListResponse> => {
  data = paginatedPiMeetingSearchListSchemaResponseTransformer(data)
  return data
}

const proxyIntermediaryVotingRecommendationSchemaResponseTransformer = (data: any) => {
  data.create_time = new Date(data.create_time)
  if (data.delete_time) {
    data.delete_time = new Date(data.delete_time)
  }
  return data
}

const providerVotingRecommendationSchemaResponseTransformer = (data: any) => {
  data.create_time = new Date(data.create_time)
  data.meeting_date = new Date(data.meeting_date)
  if (data.delete_time) {
    data.delete_time = new Date(data.delete_time)
  }
  return data
}

const proposalSetRecommendationCoverageProposalSchemaResponseTransformer = (data: any) => {
  data.proposal = proxyIntermediaryProposalSchemaResponseTransformer(data.proposal)
  if (data.proxy_intermediary_voting_recommendation) {
    data.proxy_intermediary_voting_recommendation = proxyIntermediaryVotingRecommendationSchemaResponseTransformer(
      data.proxy_intermediary_voting_recommendation
    )
  }
  if (data.provider_voting_recommendation) {
    data.provider_voting_recommendation = providerVotingRecommendationSchemaResponseTransformer(
      data.provider_voting_recommendation
    )
  }
  return data
}

const proposalSetRecommendationCoverageDetailSchemaResponseTransformer = (data: any) => {
  data.proposals = data.proposals.map((item: any) =>
    proposalSetRecommendationCoverageProposalSchemaResponseTransformer(item)
  )
  data.unmatched_provider_voting_recommendations = data.unmatched_provider_voting_recommendations.map((item: any) =>
    providerVotingRecommendationSchemaResponseTransformer(item)
  )
  return data
}

export const votingPolicyProposalSetRecommendationCoverageDetailRetrieveResponseTransformer = async (
  data: any
): Promise<VotingPolicyProposalSetRecommendationCoverageDetailRetrieveResponse> => {
  data = proposalSetRecommendationCoverageDetailSchemaResponseTransformer(data)
  return data
}

const proposalSetRecommendationCoverageSchemaResponseTransformer = (data: any) => {
  data.earliest_vote_deadline = new Date(data.earliest_vote_deadline)
  data.latest_vote_deadline = new Date(data.latest_vote_deadline)
  data.ballot_count = BigInt(data.ballot_count.toString())
  data.meeting_time = new Date(data.meeting_time)
  data.proposal_count = BigInt(data.proposal_count.toString())
  data.matched_proposal_count = BigInt(data.matched_proposal_count.toString())
  data.manually_matched_proposal_count = BigInt(data.manually_matched_proposal_count.toString())
  data.pvr_matched_proposal_count = BigInt(data.pvr_matched_proposal_count.toString())
  data.unmatched_proposal_count = BigInt(data.unmatched_proposal_count.toString())
  return data
}

const paginatedProposalSetRecommendationCoverageListSchemaResponseTransformer = (data: any) => {
  data.results = data.results.map((item: any) => proposalSetRecommendationCoverageSchemaResponseTransformer(item))
  return data
}

export const votingPolicyProposalSetRecommendationCoverageSearchCreateResponseTransformer = async (
  data: any
): Promise<VotingPolicyProposalSetRecommendationCoverageSearchCreateResponse> => {
  data = paginatedProposalSetRecommendationCoverageListSchemaResponseTransformer(data)
  return data
}

export const votingPolicyProviderVotingRecommendationsCreateResponseTransformer = async (
  data: any
): Promise<VotingPolicyProviderVotingRecommendationsCreateResponse> => {
  data = providerVotingRecommendationSchemaResponseTransformer(data)
  return data
}

const votingRecommendationSchemaResponseTransformer = (data: any) => {
  data.create_time = new Date(data.create_time)
  data.update_time = new Date(data.update_time)
  return data
}

export const votingPolicyProviderVotingRecommendationsMatchCreateResponseTransformer = async (
  data: any
): Promise<VotingPolicyProviderVotingRecommendationsMatchCreateResponse> => {
  data = votingRecommendationSchemaResponseTransformer(data)
  return data
}

const providerVotingRecommendationListResponseSchemaResponseTransformer = (data: any) => {
  data.provider_voting_recommendations = data.provider_voting_recommendations.map((item: any) =>
    providerVotingRecommendationSchemaResponseTransformer(item)
  )
  return data
}

export const votingPolicyProviderVotingRecommendationsFetchByVersionRetrieveResponseTransformer = async (
  data: any
): Promise<VotingPolicyProviderVotingRecommendationsFetchByVersionRetrieveResponse> => {
  data = providerVotingRecommendationListResponseSchemaResponseTransformer(data)
  return data
}

const paginatedProviderVotingRecommendationListSchemaResponseTransformer = (data: any) => {
  data.results = data.results.map((item: any) => providerVotingRecommendationSchemaResponseTransformer(item))
  return data
}

export const votingPolicyProviderVotingRecommendationsSearchCreateResponseTransformer = async (
  data: any
): Promise<VotingPolicyProviderVotingRecommendationsSearchCreateResponse> => {
  data = paginatedProviderVotingRecommendationListSchemaResponseTransformer(data)
  return data
}

const proxyIntermediaryVotingRecommendationConfidenceScoreSchemaResponseTransformer = (data: any) => {
  data.create_time = new Date(data.create_time)
  data.update_time = new Date(data.update_time)
  return data
}

export const votingPolicyProxyIntermediaryVotingRecommendationConfidenceScoresUpdateResponseTransformer = async (
  data: any
): Promise<VotingPolicyProxyIntermediaryVotingRecommendationConfidenceScoresUpdateResponse> => {
  data = proxyIntermediaryVotingRecommendationConfidenceScoreSchemaResponseTransformer(data)
  return data
}

export const votingPolicyProxyIntermediaryVotingRecommendationsCreateResponseTransformer = async (
  data: any
): Promise<VotingPolicyProxyIntermediaryVotingRecommendationsCreateResponse> => {
  data = proxyIntermediaryVotingRecommendationSchemaResponseTransformer(data)
  return data
}

export const votingPolicyProxyIntermediaryVotingRecommendationsMatchFromPvrCreateResponseTransformer = async (
  data: any
): Promise<VotingPolicyProxyIntermediaryVotingRecommendationsMatchFromPvrCreateResponse> => {
  data = proxyIntermediaryVotingRecommendationSchemaResponseTransformer(data)
  return data
}

const paginatedProxyIntermediaryVotingRecommendationListSchemaResponseTransformer = (data: any) => {
  data.results = data.results.map((item: any) => proxyIntermediaryVotingRecommendationSchemaResponseTransformer(item))
  return data
}

export const votingPolicyProxyIntermediaryVotingRecommendationsSearchCreateResponseTransformer = async (
  data: any
): Promise<VotingPolicyProxyIntermediaryVotingRecommendationsSearchCreateResponse> => {
  data = paginatedProxyIntermediaryVotingRecommendationListSchemaResponseTransformer(data)
  return data
}

export const votingPolicyProxyIntermediaryVotingRecommendationsVersionsRetrieveResponseTransformer = async (
  data: any
): Promise<VotingPolicyProxyIntermediaryVotingRecommendationsVersionsRetrieveResponse> => {
  data = proxyIntermediaryVotingRecommendationSchemaResponseTransformer(data)
  return data
}

const votingPolicySchemaResponseTransformer = (data: any) => {
  data.create_time = new Date(data.create_time)
  data.update_time = new Date(data.update_time)
  return data
}

export const votingPolicyVotingPoliciesCreateResponseTransformer = async (
  data: any
): Promise<VotingPolicyVotingPoliciesCreateResponse> => {
  data = votingPolicySchemaResponseTransformer(data)
  return data
}

export const votingPolicyVotingPoliciesRetrieveResponseTransformer = async (
  data: any
): Promise<VotingPolicyVotingPoliciesRetrieveResponse> => {
  data = votingPolicySchemaResponseTransformer(data)
  return data
}

export const votingPolicyVotingPoliciesPartialUpdateResponseTransformer = async (
  data: any
): Promise<VotingPolicyVotingPoliciesPartialUpdateResponse> => {
  data = votingPolicySchemaResponseTransformer(data)
  return data
}

const votingPolicyDocumentSchemaResponseTransformer = (data: any) => {
  data.create_time = new Date(data.create_time)
  data.update_time = new Date(data.update_time)
  data.issue_time = new Date(data.issue_time)
  return data
}

const paginatedVotingPolicyDocumentListSchemaResponseTransformer = (data: any) => {
  data.results = data.results.map((item: any) => votingPolicyDocumentSchemaResponseTransformer(item))
  return data
}

export const votingPolicyVotingPoliciesDocumentsListResponseTransformer = async (
  data: any
): Promise<VotingPolicyVotingPoliciesDocumentsListResponse> => {
  data = paginatedVotingPolicyDocumentListSchemaResponseTransformer(data)
  return data
}

export const votingPolicyVotingPoliciesDocumentsCreateResponseTransformer = async (
  data: any
): Promise<VotingPolicyVotingPoliciesDocumentsCreateResponse> => {
  data = votingPolicyDocumentSchemaResponseTransformer(data)
  return data
}

export const votingPolicyVotingPoliciesDocumentsRetrieveResponseTransformer = async (
  data: any
): Promise<VotingPolicyVotingPoliciesDocumentsRetrieveResponse> => {
  data = votingPolicyDocumentSchemaResponseTransformer(data)
  return data
}

export const votingPolicyVotingPoliciesDocumentsPartialUpdateResponseTransformer = async (
  data: any
): Promise<VotingPolicyVotingPoliciesDocumentsPartialUpdateResponse> => {
  data = votingPolicyDocumentSchemaResponseTransformer(data)
  return data
}

export const votingPolicyVotingPoliciesVotingRecommendationsCreateResponseTransformer = async (
  data: any
): Promise<VotingPolicyVotingPoliciesVotingRecommendationsCreateResponse> => {
  data = votingRecommendationSchemaResponseTransformer(data)
  return data
}

export const votingPolicyVotingPoliciesVotingRecommendationsRetrieveResponseTransformer = async (
  data: any
): Promise<VotingPolicyVotingPoliciesVotingRecommendationsRetrieveResponse> => {
  data = votingRecommendationSchemaResponseTransformer(data)
  return data
}

export const votingPolicyVotingPoliciesVotingRecommendationsPartialUpdateResponseTransformer = async (
  data: any
): Promise<VotingPolicyVotingPoliciesVotingRecommendationsPartialUpdateResponse> => {
  data = votingRecommendationSchemaResponseTransformer(data)
  return data
}

export const votingPolicyVotingPoliciesVotingRecommendationsUpdateFromPvrCreateResponseTransformer = async (
  data: any
): Promise<VotingPolicyVotingPoliciesVotingRecommendationsUpdateFromPvrCreateResponse> => {
  data = votingRecommendationSchemaResponseTransformer(data)
  return data
}

const paginatedVotingRecommendationListSchemaResponseTransformer = (data: any) => {
  data.results = data.results.map((item: any) => votingRecommendationSchemaResponseTransformer(item))
  return data
}

export const votingPolicyVotingPoliciesVotingRecommendationsSearchCreateResponseTransformer = async (
  data: any
): Promise<VotingPolicyVotingPoliciesVotingRecommendationsSearchCreateResponse> => {
  data = paginatedVotingRecommendationListSchemaResponseTransformer(data)
  return data
}

const paginatedVotingPolicyListSchemaResponseTransformer = (data: any) => {
  data.results = data.results.map((item: any) => votingPolicySchemaResponseTransformer(item))
  return data
}

export const votingPolicyVotingPoliciesSearchCreateResponseTransformer = async (
  data: any
): Promise<VotingPolicyVotingPoliciesSearchCreateResponse> => {
  data = paginatedVotingPolicyListSchemaResponseTransformer(data)
  return data
}

const votingRecommendationConfidenceScoreSchemaResponseTransformer = (data: any) => {
  data.create_time = new Date(data.create_time)
  data.update_time = new Date(data.update_time)
  return data
}

export const votingPolicyVotingRecommendationConfidenceScoresUpdateResponseTransformer = async (
  data: any
): Promise<VotingPolicyVotingRecommendationConfidenceScoresUpdateResponse> => {
  data = votingRecommendationConfidenceScoreSchemaResponseTransformer(data)
  return data
}
